import React, { useEffect, useState } from 'react'
//components
import { Button } from "../../../../components/ui/buttons/Button"
import Label from '../../../../components/ui/labels/Label'
import { SelectContainer } from '../../../../components/ui/layout/SelectContainer'
import Select from "react-select"
//hooks
import useJobOptions from "../../../../hooks/useJobOptions";
import { useLoading } from '../../../../contexts/LoadingContext';
import { useError } from '../../../../contexts/ErrorContext';
import { useSuccess } from '../../../../contexts/SuccessContext';
//api
import { getJobsAssignedToUserAPI, assignJobToUserAPI, unassignJobFromUserAPI } from "../../../../services/jobPermissionsAPI"
import { InputContainer } from '../../../../components/ui/inputs/InputContainers';

/**
 * 
 * Component for updating the user's jobs
 * 
 * @param {DropdownOption | null} selectedUser - user selected in parent, looks like: {value: 1, label: "FirstName LastName"}
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Admin Dashboard
 */
export const UserJobs = ({selectedUser}) => {
    
    const [userJobs, setUserJobs] = useState([])
    const [userJobsOriginal, setUserJobsOriginal] = useState([])

    const { showLoading, hideLoading } = useLoading()
    const {showError} = useError()
    const { jobNameOptions } = useJobOptions()
    const {timeoutSuccess} = useSuccess()

    //fetch data and set state
    const fetchUserJobs = async(userID) => {
        showLoading("Getting user jobs...")
        const response = await getJobsAssignedToUserAPI(userID);

        if (!response.success) {
            hideLoading()

            showError(`Error getting user's jobs: ${response.message}`)

            return
        }
        
        const formattedJobs = response.data.map(userJob => ({
            value: userJob.JobID,
            label: `Job_${userJob.Job_Number}_${userJob.Job_Name}`
        }));

        setUserJobs(formattedJobs)
        setUserJobsOriginal(formattedJobs)
        
        hideLoading()
    
    }

    //fetch data when selectedUser changes in the parent
    useEffect(() => {
        if(selectedUser){
            
            fetchUserJobs(selectedUser.value)

        }

    }, [selectedUser])


    const handleSubmit = async() => {
        showLoading("Submitting...")

        // get ids from current and original jobsAssigned
        const jobsAssignedIds = userJobs.map(job => job.value);
        const jobsAssignedOriginalIds = userJobsOriginal.map(job => job.value);
    
        // compare ids between current and original user groups to determine which to add and remove
        const jobsToAdd = userJobs.filter(job => !jobsAssignedOriginalIds.includes(job.value));
    
        const jobsToRemove = userJobsOriginal.filter(job => !jobsAssignedIds.includes(job.value));

        //loop through each and call api
        if(jobsToAdd.length > 0){
            for(const job of jobsToAdd){
                const response = await assignJobToUserAPI(job.value, selectedUser.value)
                    
                if(!response.success){
                    hideLoading()

                    showError(`Error adding jobs: ${response.message}`)
        
                    return
                }
            }
        }

        if(jobsToRemove.length > 0){
            for(const job of jobsToRemove){
                const response = await unassignJobFromUserAPI(job.value, selectedUser.value)
                    
                if(!response.success){
                    hideLoading()

                    showError(`Error removing jobs: ${response.message}`)
        
                    return
                }
            }
        }

        //update original state
        setUserJobsOriginal(userJobs)
        
        hideLoading()
        
        timeoutSuccess("Jobs saved")
    }


    return (

        <div className='mb-10'>
            <InputContainer>
                <Label htmlFor='jobDropdown'>Jobs assigned to user</Label>

                <SelectContainer>
                    <Select
                        value={userJobs}
                        options={jobNameOptions}
                        name="usersJobDropdown"
                        onChange={(x) => setUserJobs(x)}
                        menuPosition='fixed'
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        isMulti={true}
                    />
                </SelectContainer>
                
                <Button variant='success' onClick={() => handleSubmit()} className='max-w-max'>Update Jobs</Button>
                
            </InputContainer>

        </div>

    )
}